import { InjectionToken } from '@angular/core';
import { SapPriceCampaignDetails } from '../../../model';
import { Occ } from '../../../occ';
import { Converter } from '../../../util/converter.service';

export const PRICE_CAMPAIGN_DETAILS_NORMALIZER = new InjectionToken<
  Converter<Occ.SapPriceCampaignDetails, SapPriceCampaignDetails>
>('PriceCampaignNormalizer');
